module.exports = __webpack_public_path__ + "static/Template_logobase_1-29909e21d627defb687fdea39ea0cb4d.png";